import React from 'react';

import { DashboardConfigurationFilter } from '../types';
import { useCountConfiguration } from '../useCountConfiguration';

import Filters from './Filters/Filters';
import { buildSearchFilterForParsingError, libelleParsingError } from './utils';

import './DashboardConfigurationHeader.less';

interface DashboardConfigurationHeaderProps {
  totalResult: number;
  filter: Partial<DashboardConfigurationFilter>;
  setFilter: (value: Partial<DashboardConfigurationFilter>) => void;
}

function DashboardConfigurationHeader({
  totalResult,
  filter,
  setFilter,
}: DashboardConfigurationHeaderProps): React.ReactElement {
  const countString = `${totalResult} ${
    totalResult > 1 ? 'configurations' : 'configuration'
  }`;

  const { data: count } = useCountConfiguration(
    buildSearchFilterForParsingError(filter),
  );

  const separator = ', ';
  const countParsingError = libelleParsingError(count);

  return (
    <>
      <div>
        <Filters filter={filter} setFilter={setFilter} />
      </div>
      <p>
        {countString}
        {countParsingError && (
          <>
            {separator}
            <span
              className="parsingError"
              onClick={() => {
                setFilter({
                  ...filter,
                  hasError: true,
                });
              }}
            >
              {countParsingError}
            </span>
          </>
        )}
      </p>
    </>
  );
}

export default DashboardConfigurationHeader;
